// "A new version is ready — Refresh" (V0.4.9). Each build writes /version.json (vite.config.ts); the app checks it
// every 5 minutes and whenever the tab comes back into view, and offers a refresh when the build has changed.
import { useEffect, useState } from 'react';
import { APP_VERSION } from '../lib/version';

declare const __PMC3_BUILD__: string;
const MINE = typeof __PMC3_BUILD__ === 'string' ? __PMC3_BUILD__ : 'dev';
const EVERY = 5 * 60 * 1000;
const SNOOZE = 30 * 60 * 1000;

type Live = { version: string; build: string; note?: string };

export function UpdateNotice() {
  const [live, setLive] = useState<Live | null>(null);
  const [snoozed, setSnoozed] = useState(0);

  useEffect(() => {
    if (MINE === 'dev') return;
    let stop = false;
    const check = async () => {
      if (document.visibilityState === 'hidden') return;
      try {
        const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const v = (await r.json()) as Live;
        if (!stop && v.build && v.build !== MINE) setLive(v);
      } catch {
        /* offline — try again later */
      }
    };
    void check();
    const t = setInterval(() => void check(), EVERY);
    const vis = () => document.visibilityState === 'visible' && void check();
    document.addEventListener('visibilitychange', vis);
    window.addEventListener('focus', vis);
    return () => {
      stop = true;
      clearInterval(t);
      document.removeEventListener('visibilitychange', vis);
      window.removeEventListener('focus', vis);
    };
  }, []);

  if (!live || Date.now() < snoozed) return null;
  const same = live.version === APP_VERSION;
  return (
    <div className="updbar" role="status" aria-live="polite">
      <span className="upd-dot" aria-hidden="true" />
      <div className="upd-text">
        <b>{same ? 'PM C3 has been updated' : `PM C3 V${live.version} is ready`}</b>
        <span>{live.note ? live.note : 'Refresh to get the latest version.'} Save what you are typing first.</span>
      </div>
      <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
        Refresh
      </button>
      <button type="button" className="btn btn-ghost" onClick={() => setSnoozed(Date.now() + SNOOZE)}>
        Later
      </button>
    </div>
  );
}
